import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BaseAutoCompleteWithMultipleSelectedItems from '@/components/AutoCompletes/BaseAutoCompleteWithMultipleSelectedItems.vue';
import getManagementOffice from '@/types/responses/getManagementOffice';
import getOperationOffice from '@/types/responses/getOperationOffice';
import { onMounted, ref, computed } from 'vue';
import Api from '@/services/api/ApiServiceFabrick';


export default /*@__PURE__*/_defineComponent({
  __name: 'MultipleOperationOfficeAutoComplete',
  props: {
    modelValue: {},
    managementOffice: {},
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const items = ref<getOperationOffice[]>([]);

onMounted(() => {
  Api()
    .autoCompleteOperationOffices()
    .then((data) => {
      items.value = data;
    });
});

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseAutoCompleteWithMultipleSelectedItems, {
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    label: "運営会社",
    itemName: "name",
    items: items.value,
    "management-office": props.managementOffice,
    errorMessages: props.errorMessages
  }, null, 8, ["modelValue", "items", "management-office", "errorMessages"]))
}
}

})